import { useEffect, useState } from 'react'
import axios from 'axios'
import { PackageCheck } from 'lucide-react'
import PageHeader from '../components/PageHeader'
import OrderList from '../components/OrderList'
import type { ShopOrder } from '../types/Shop'

const MyOrders = () => {
  const [orders, setOrders] = useState<ShopOrder[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    axios.get<ShopOrder[]>('/api/shop/orders/me')
      .then(({ data }) => { setOrders(data); setError('') })
      .catch(() => setError('Impossible de charger vos commandes.'))
      .finally(() => setLoading(false))
  }, [])

  return (
    <div className="space-y-8">
      <PageHeader eyebrow="Espace adhérent" title="Mes commandes" description="Suivez la préparation, le paiement et le retrait de vos commandes au club." icon={<PackageCheck />} />
      {loading ? <div className="shop-orders-loading">Chargement de vos commandes…</div> : error ? <div className="shop-error-box">{error}</div> : <OrderList orders={orders} />}
    </div>
  )
}

export default MyOrders
